import axios from "axios";

const baseURL = process.env.VUE_APP_API_URL;
const token = process.env.VUE_APP_ACCESS_TOKEN;
const defaultLanguage = 'en';

export function getTranslation(field, translations = [], locale) {
  let result = translations.find(m => m.Field == field);

  return !result ? "": result[locale] || result[defaultLanguage];

}